export const exportToCSV = (data: any[], fileName: string): void => {
  if (!data || data.length === 0) {
    console.error('No data available to export');
    return;
  }

  const csvRows = [];

  // Generate header row
  const headers = Object.keys(data[0]);
  csvRows.push(headers.join(','));

  // Generate data rows
  data.forEach(row => {
    const values = headers.map(header => row[header]);
    csvRows.push(values.join(','));
  });

  // Create CSV file blob
  const csvContent = csvRows.join('\n');
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);

  // Trigger download
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', `${fileName}.csv`);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};